import { createAction } from 'redux-actions'

const Actions = {
  START_INIT: 'START_INIT',
  FINISH_INIT: 'FINISH_INIT',
  SET_TOKEN: 'SET_TOKEN',
  RECEIVE_MEASUREMENTS: 'RECEIVE_MEASUREMENTS',
  OK_CLICKED: 'OK_CLICKED',
  NOK_CLICKED: 'NOK_CLICKED',
  OK_CLOSE_CLICKED: 'OK_CLOSE_CLICKED',
  NOK_CLOSE_CLICKED: 'NOK_CLOSE_CLICKED',
  OK_CONFIRM_CLICKED: 'OK_CONFIRM_CLICKED',
  NOK_CONFIRM_CLICKED: 'NOK_CONFIRM_CLICKED',
  STATUS_SENT: 'STATUS_SENT'
}

export default Actions

export const setToken = createAction(Actions.SET_TOKEN)
export const startInit = createAction(Actions.START_INIT)
export const finishInit = createAction(Actions.FINISH_INIT)
export const receiveMeasurements = createAction(Actions.RECEIVE_MEASUREMENTS)
export const okClicked = createAction(Actions.OK_CLICKED)
export const nokClicked = createAction(Actions.NOK_CLICKED)
export const okCloseClicked = createAction(Actions.OK_CLOSE_CLICKED)
export const nokCloseClicked = createAction(Actions.NOK_CLOSE_CLICKED)
export const okConfirmClicked = createAction(Actions.OK_CONFIRM_CLICKED)
export const nokConfirmClicked = createAction(Actions.NOK_CONFIRM_CLICKED)
export const statusSent = createAction(Actions.STATUS_SENT)
